import { NavLink } from 'react-router-dom'
import { PAGE_INFO } from '../../help/content'

// Primary destinations. Kept small for now; will grow over time.
const TABS = [
  { label: 'Code', to: '/code' },
  { label: 'Searchrooms', to: '/searchrooms' },
  { label: 'Global AI Search', to: '/global-ai-search' },
  { label: 'Global Text Search', to: '/global-text-search' },
  { label: 'Notes', to: '/notebooks' },
  { label: 'Guides', to: '/guides' },
  { label: 'Topics', to: '/topics' },
  { label: 'Chat', to: '/chat' },
  { label: 'Network', to: '/network' },
  { label: 'Projects', to: '/projects' },
]

function tabClass({ isActive }) {
  return 'app-navtab' + (isActive ? ' is-active' : '')
}

function NavTabs() {
  return (
    <nav className="app-navtabs" aria-label="Primary">
      {TABS.map((tab) => (
        <NavLink key={tab.to} to={tab.to} className={tabClass} title={PAGE_INFO[tab.to]}>
          {tab.label}
        </NavLink>
      ))}
    </nav>
  )
}

export default NavTabs
